import { Component, Prop, State, h } from '@stencil/core';
import { getServiceNumber } from '../../utils/ttarp';
import { isBrowser } from '../../constants/constants';
import supportIcon from '../../assets/support_red.svg';

const pushedEvents = new Set<string>();

@Component({
  tag: 'customer-contact',
  styleUrl: 'customer-contact.scss',
  shadow: true,
})
export class CustomerContact {
  @State() resolvedServiceNumber: string
  @Prop() serviceNumber: string;

  connectedCallback() {
    if (isBrowser) {
      this.pushDataLayerEvent();
    }
  }

  private async pushDataLayerEvent() {
    this.resolvedServiceNumber =
      this.serviceNumber ?? (await getServiceNumber());

    if (this.resolvedServiceNumber && !pushedEvents.has(this.resolvedServiceNumber)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ttarp_number_shown',
        ttarp_value: this.resolvedServiceNumber,
      });
      pushedEvents.add(this.resolvedServiceNumber);
    }
  }
  render() {
    return isBrowser && (
      <div class="ghf-customerContact--default">
        <div>
          <a class="ciHeader-phoneNumberLink" title="Customer Support Headset" href={`tel:${this.resolvedServiceNumber}`} >
            <img src={supportIcon} alt="Customer Support Headset" class="ghf-customerContact-icon" />
          </a>
          <span class="ghf-customerContact-helpText">Help</span>
        </div>
        <div>
          <span class="ghf-customerContact-text">Talk to a Real Person</span>
          <a class="ghf-customerContact-storeText ciHeader-phoneNumberLink" href={`tel:${this.resolvedServiceNumber}`}>
            {this.resolvedServiceNumber}
          </a>
        </div>
      </div>
    );
  }
}
